import type { Language } from './types';

export const isLanguage = (value: unknown): value is Language =>
  value === 'pt-BR' || value === 'en' || value === 'es' || value === 'fr';

export const detectLanguage = (): Language => {
  try {
    const saved = typeof window !== 'undefined' ? window.localStorage.getItem('app-language') : null;
    return isLanguage(saved) ? saved : 'pt-BR';
  } catch {
    return 'pt-BR';
  }
};
